import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="code-editor"
export default class extends Controller {
  static targets = ['tabs', 'panels', 'filelink']
  static debounces = ["searchFiles"]
  static values = { userId: String, themeId: String }

  connect() {
    // useDebounce(this, { wait: 300 })
    this.restoreTabs()
  }

  openTab(e) {
    e?.preventDefault()
    const target = e.target.closest('a')
    let tab = this.tabsTarget.querySelector(`[data-tab-id="${target.dataset.tabId}"]`)
    if (tab) {
      tab.click();
    } else {
      this.createTab(target.dataset.tabId, target.dataset.title, target.href)
    }
  }

  removeTab(e) {
    e?.preventDefault()
    const target = e.target.closest('a')
    const index = Array.prototype.indexOf.call(this.tabsTarget.children, target);
    this.tabsTarget.children[index].remove()
    this.panelsTarget.children[index].remove()
    this.removeTabFromLocalStorage(target.dataset.tabId)
  }

  save(e) {
    e?.preventDefault()
    this.formTarget.submit()
  }

  createTab(tabId, title, url) {
    const tabHtml = `
      <a cursorshover="true" role="tab" class="tab" data-ui--tabs-target="tab" data-tab-id="${tabId}">
        <div class="flex justify-between gap-3">
        <span class="normal-case">${title}</span>
        <span data-action="click->code-editor#removeTab">X</span>
        </div>
      </a>
    `
    const panelHtml = `
      <div data-ui--tabs-target="panel" data-tab-id="${tabId}">
        <turbo-frame id="${tabId}" src="${url}" loading="lazy"></turbo-frame>
      </div>
    `
    this.tabsTarget.insertAdjacentHTML('beforeend', tabHtml)
    this.panelsTarget.insertAdjacentHTML('beforeend', panelHtml)
    this.addTabToLocalStorage(tabId, title, url, this.tabsTarget.children.length - 1)
    setTimeout(() => {
      this.tabsTarget.querySelector(`[data-tab-id="${tabId}"]`).click()
    }, 10)
  }

  addTabToLocalStorage(tabId, title, url, index) {
    const tabs = this.tabsState
    if (tabs.find(tab => tab.tabId === tabId)) return;

    tabs.push({ tabId, title, url, index })
    localStorage.setItem(this.storageKey, JSON.stringify(tabs))
  }

  removeTabFromLocalStorage(tabId) {
    const tabs = this.tabsState
    const index = tabs.findIndex(tab => tab.tabId === tabId)
    tabs.splice(index, 1)
    localStorage.setItem(this.storageKey, JSON.stringify(tabs))
  }

  restoreTabs() {
    if (this.tabsState.length) {
      this.tabsState.forEach(tab => {
        this.createTab(tab.tabId, tab.title, tab.url)
      })
    }
  }

  filelinkTargetConnected(el) {
    if (el.dataset.open == 'true') {
      const tabId = el.dataset.tabId
      const title = el.dataset.title
      const url = el.href
      this.createTab(tabId, title, url)
    }
  }

  filelinkTargetDisconnected(el) {
    const tabId = el.dataset.tabId
    const tab = this.tabsTarget.querySelector(`[data-tab-id="${tabId}"]`)
    const panel = this.panelsTarget.querySelector(`[data-tab-id="${tabId}"]`)
    this.removeTabFromLocalStorage(tabId)
    tab?.remove()
    panel?.remove()
  }

  get storageKey() {
    return `theme_editor_tabs_${this.userIdValue}_${this.themeIdValue}`
  }

  get tabsState() {
    return JSON.parse(localStorage.getItem(this.storageKey)) || []
  }
}
